/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateOverwolfGameBodySteamData
 */
export interface CreateOverwolfGameBodySteamData {
    /**
     * Game display name
     * @type {string}
     * @memberof CreateOverwolfGameBodySteamData
     */
    name?: string;
    /**
     * Full game description
     * @type {string}
     * @memberof CreateOverwolfGameBodySteamData
     */
    description?: string;
    /**
     * Brief game description
     * @type {string}
     * @memberof CreateOverwolfGameBodySteamData
     */
    shortDescription?: string;
    /**
     * Game genres
     * @type {Array<string>}
     * @memberof CreateOverwolfGameBodySteamData
     */
    genres?: Array<string>;
    /**
     * Game developers
     * @type {Array<string>}
     * @memberof CreateOverwolfGameBodySteamData
     */
    developers?: Array<string>;
    /**
     * Game publishers
     * @type {Array<string>}
     * @memberof CreateOverwolfGameBodySteamData
     */
    publishers?: Array<string>;
    /**
     * Game release date
     * @type {string}
     * @memberof CreateOverwolfGameBodySteamData
     */
    releaseDate?: string;
    /**
     * Header image URL (460x215)
     * @type {string}
     * @memberof CreateOverwolfGameBodySteamData
     */
    headerImage?: string;
    /**
     * Capsule image URL
     * @type {string}
     * @memberof CreateOverwolfGameBodySteamData
     */
    capsuleImage?: string;
    /**
     * Capsule image v5 URL
     * @type {string}
     * @memberof CreateOverwolfGameBodySteamData
     */
    capsuleImageV5?: string;
    /**
     * Background image URL
     * @type {string}
     * @memberof CreateOverwolfGameBodySteamData
     */
    background?: string;
    /**
     * Raw background image URL
     * @type {string}
     * @memberof CreateOverwolfGameBodySteamData
     */
    backgroundRaw?: string;
    /**
     * Game website URL
     * @type {string}
     * @memberof CreateOverwolfGameBodySteamData
     */
    website?: string;
}

/**
 * Check if a given object implements the CreateOverwolfGameBodySteamData interface.
 */
export function instanceOfCreateOverwolfGameBodySteamData(value: object): value is CreateOverwolfGameBodySteamData {
    return true;
}

export function CreateOverwolfGameBodySteamDataFromJSON(json: any): CreateOverwolfGameBodySteamData {
    return CreateOverwolfGameBodySteamDataFromJSONTyped(json, false);
}

export function CreateOverwolfGameBodySteamDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateOverwolfGameBodySteamData {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'shortDescription': json['shortDescription'] == null ? undefined : json['shortDescription'],
        'genres': json['genres'] == null ? undefined : json['genres'],
        'developers': json['developers'] == null ? undefined : json['developers'],
        'publishers': json['publishers'] == null ? undefined : json['publishers'],
        'releaseDate': json['releaseDate'] == null ? undefined : json['releaseDate'],
        'headerImage': json['headerImage'] == null ? undefined : json['headerImage'],
        'capsuleImage': json['capsuleImage'] == null ? undefined : json['capsuleImage'],
        'capsuleImageV5': json['capsuleImageV5'] == null ? undefined : json['capsuleImageV5'],
        'background': json['background'] == null ? undefined : json['background'],
        'backgroundRaw': json['backgroundRaw'] == null ? undefined : json['backgroundRaw'],
        'website': json['website'] == null ? undefined : json['website'],
    };
}

export function CreateOverwolfGameBodySteamDataToJSON(json: any): CreateOverwolfGameBodySteamData {
    return CreateOverwolfGameBodySteamDataToJSONTyped(json, false);
}

export function CreateOverwolfGameBodySteamDataToJSONTyped(value?: CreateOverwolfGameBodySteamData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'description': value['description'],
        'shortDescription': value['shortDescription'],
        'genres': value['genres'],
        'developers': value['developers'],
        'publishers': value['publishers'],
        'releaseDate': value['releaseDate'],
        'headerImage': value['headerImage'],
        'capsuleImage': value['capsuleImage'],
        'capsuleImageV5': value['capsuleImageV5'],
        'background': value['background'],
        'backgroundRaw': value['backgroundRaw'],
        'website': value['website'],
    };
}

